import { Box, Stack } from '@mui/material';
import { FC } from 'react';

import { AbgTypography, mergeSxWithStylePart } from '@abg/kit-base';

import { VehicleCardSubtitle } from '../../../../organisms/VehicleList/v2/organisms/VehicleCardV2/components/VehicleCardSubtitle';
import { VehicleCardTitle } from '../../../../organisms/VehicleList/v2/organisms/VehicleCardV2/components/VehicleCardTitle';
import { AemImage } from '../../../AemImage';

import { headerImageContainer } from './car-info-header.styling';
import { CarInfoHeaderParameters } from './car-info-header.types';

import vehicleOnErrorImage from '../../../../../assets/car-not-available.png';

export const CarInfoHeader: FC<CarInfoHeaderParameters> = ({
  styleParts,
  vehicleType,
  vehicleImage,
  vehicleDescription,
  isAvisFirst,
  accordionPanelImageStyle = {},
}) => {
  return (
    <Stack
      direction="row"
      component="div"
      alignItems="center"
      justifyContent="space-between"
      sx={styleParts?.headerContainer || {}}
    >
      <Box>
        {isAvisFirst ? (
          <VehicleCardTitle
            subtype="avis-first"
            showEmeaV2Label
            data-testid="rental-summary-title"
            sx={{ mb: '6px' }}
          >
            {vehicleType || ''}
          </VehicleCardTitle>
        ) : (
          <AbgTypography
            variant="h5"
            sx={mergeSxWithStylePart({}, styleParts, 'header')}
            data-testid="rental-summary-title"
          >
            {vehicleType || ''}
          </AbgTypography>
        )}

        {vehicleDescription &&
          (isAvisFirst ? (
            <VehicleCardSubtitle data-testid="rental-summary-description">
              {vehicleDescription}
            </VehicleCardSubtitle>
          ) : (
            <AbgTypography
              component="h6"
              variant="subtitle2"
              sx={{
                color: 'text.secondary',
                marginTop: '4px',
                textTransform: 'uppercase',
              }}
              data-testid="rental-summary-description"
            >
              {vehicleDescription}
            </AbgTypography>
          ))}
      </Box>

      <Box
        sx={mergeSxWithStylePart(
          headerImageContainer,
          styleParts,
          'headerImageContainer',
        )}
      >
        <AemImage
          data-testid="rental-summary-image"
          src={vehicleImage ?? ''}
          alt="vehicle image"
          {...accordionPanelImageStyle}
          style={{ objectFit: 'contain', maxWidth: '100%' }}
          fallbackSrc={vehicleOnErrorImage}
        />
      </Box>
    </Stack>
  );
};
